import React from "react";
import CustomChip from "../../../../components/Chip";
import CustomButton from "../../../../components/AddButton";
import { edit } from "../../../../common/svg";

interface LiveStatusItem {
  label: string;
  value: string;
  status: string;
}

const liveStatus: LiveStatusItem[] = [
  {
    label: "Current Point",
    value: "Loading Point",
    status: "on the way",
  },
  {
    label: "Task Type",
    value: "Empt - Warehouse",
    status: "2nd Vehicle",
  },
  {
    label: "Route Status",
    value: "Good",
    status: "ETA 15.45 Hrs",
  },
  {
    label: "Container Status",
    value: "Cargo Loaded",
    status: "30.5 Tons",
  },
  {
    label: "Clearance Status",
    value: "Not yet",
    status: "2 days 12 Hr in CFH",
  },
  {
    label: "Delivery Status",
    value: "In Port",
    status: "2 days 12 Hr in Port",
  },
];

const LiveStatus: React.FC = () => {
  const handleClick = () => {
    console.log("Edit button clicked");
  };

  return (
    <div className="px-3 py-2 border-b border-[#C1C1C1] border-dashed">
      <div className="flex gap-1">
        <p className="whitespace-nowrap text-[16px] leading-[30px] font-[600]">
          Live Status
        </p>
        <CustomChip
          className="whitespace-nowrap"
          text="Waiting for clearance"
          backgroundColor="#FFF5EC"
          textColor="#FFB470"
          borderColor="#FFB470"
        />
        <div className="flex self-end" style={{ marginLeft: "630px" }}>
          <CustomButton label="" icon={edit} onClick={handleClick} />
        </div>
      </div>

      <div className="flex justify-between gap-1">
        {liveStatus.map((status, index) => (
          <div key={index}>
            <p className="text-[14px] text-[#7E7E7E] font-[400]">
              {status.label}
            </p>
            <p className="text-[14px] font-[400]">{status.value}</p>
            <p className="text-[14px] font-[400] text-[#7E7E7E]">
              {status.status}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LiveStatus;
